<template>
  <div class="h-full">
    <div class="flex h-full justify-end items-center">
      <p @click="openAssignes = true" style="color:#29ABE2;" class="font-bold cursor-pointer">Assigned</p>
      <vs-dropdown style="margin-left: 5px; cursor: pointer" vs-custom-content vs-trigger-click>
        <vs-button color="primary" type="border" icon-pack="feather" icon="icon-more-vertical"></vs-button>

        <vs-dropdown-menu style="min-width: 100px">
          <vs-dropdown-item @click="pdfPreview">Preview</vs-dropdown-item>
          <vs-dropdown-item @click="notesDownload">Download</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>


      <!-- <vs-dropdown
        style="margin-left: 5px; cursor: pointer"
        vs-custom-content
        vs-trigger-click
      >
        <vs-button
          color="primary"
          type="border"         //by shankhadeepa
          icon-pack="feather"
          icon="icon-more-vertical"
        ></vs-button>

        <vs-dropdown-menu style="min-width: 100px">
          <vs-dropdown-item @click="openConfirm()">Delete</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown> -->
    </div>
    <div v-if="openAssignes">
      <AssignListComponent :openAssignes="openAssignes" :receivers="params.data" @closeAssigned="closeAssigned" />
    </div>
    <div v-if="pdfPreviewModal">
      <PdfPreviewModalComponent :pdfPreviewModal="pdfPreviewModal" :pdfDetails="this.params.data"
        @pdfPreviewModalClose="pdfPreviewModalClose" />
    </div>
  </div>
</template>

<script>
import { deleteNoteTemplate, notesDownload } from '@/api/lesson_notes.js'
import AssignListComponent from '@/views/pages/v1/notes/components/Notes/assignList.vue'
import PdfPreviewModalComponent from '@/views/pages/v1/notes/components/Notes/PdfPreviewModalComponent.vue'
import axios from 'axios'

export default {
  name: 'CellRendererAction',
  data () {
    return {
      openAssignes: false,
      customer_id: localStorage.getItem('customer_id'),
      pdfPreviewModal: false
    }
  },
  mounted () {},
  components: {
    AssignListComponent,
    axios,
    PdfPreviewModalComponent
  },
  methods: {
    pdfPreviewModalClose () {
      this.pdfPreviewModal = false
    },
    pdfPreview () {
      this.pdfPreviewModal = true
    },
    async notesDownload () {
      const { data } = await notesDownload(this.customer_id, this.params.data.id)
      this.downloadItem({
        url: data.data.url,
        label: data.data.name
      })
      this.showSuccessMessage('Success', 'Notes downloaded successfully', 'success')
    },
    downloadItem ({ url, label }) {
      axios
        .get(url, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'mime' })

          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${label}.${url.split('.')[url.split('.').length - 1]
          }`
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    },
    closeAssigned () {
      this.openAssignes = false
    },
    openConfirm () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure, you want to delete this template?',
        accept: this.acceptAlert
      })
    },
    acceptAlert () {
      this.deleteAssignment()
    },
    async deleteAssignment () {
      try {

        await deleteNoteTemplate(this.customer_id, this.params.data.id)

        this.showSuccessMessage('Success', 'Deleted Successfully', 'success')
        this.params.colDef.filterParams.fetchNotes()
      } catch (error) {
        console.log(error)
      }
    },
    coursePreviewNewTab () {
      this.$router.push({
        name: 'course preview',
        params: {
          course_open_type: 'preview',
          course_id: this.params.data.id
        }
      })
    }
  }
}
</script>
